import axios from './../axios';
import { toQuery } from '@/plugins/toQuery';

export const getProduct = async (id) => {
  try {
    const res = await axios.get(`/products/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const getSupplierDetails = async (id) => {
  try {
    const res = await axios.get(`/supplier_details/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const getRelatedProducts = async (product_id, service_id) => {
  try {
    const res = await axios.get(`/related_products`, {
      params: {
        product_id,
        service_id,
      },
    });
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const getProducs = async (query = { page: 1 }) => {
  try {
    const res = await axios.get(`/products?${toQuery(query)}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};